<template>
  <MaskComponent dialogType="spend" v-show="$bus.spendDialogShow">
    <div class="dialog-spend">
      <div class="dialog-spend-title">{{ getDialogSpendTitle }}</div>
      <div class="prize-item">
        <div class="prize-item-img" :class="getClass">
          <img :src="$bus.prize.item_img" alt="prize" />
          <PrizeNum :num="$bus.prize.item_num" />
        </div>
        <div class="prize-item-name">{{ $bus.prize.item_name }}</div>
        <div class="prize-item-price">
          <div class="prize-item-price-discount">
            <span class="diamond"></span>
            <span
              class="prize-item-price-discount-value"
            >{{ getPrice }}</span>
          </div>
          <div class="prize-item-price-origin" v-show="$bus.currentDiscount < 100">
            <span class="diamond"></span>
            <span class="prize-item-price-origin-value">{{ $bus.prize.price }}</span>
            <span class="del"></span>
          </div>
        </div>
      </div>
      <div class="dialog-spend-button">
        <DialogButton :disabled="false" :text="getDialogButtonText" @clickDialogButton="confirm" />
      </div>
      <div class="dialog-spend-tip">
        <span class="dialog-spend-tip-icon">*</span>
        <span class="dialog-spend-tip-text">{{ getText }}</span>
      </div>
    </div>
  </MaskComponent>
</template>

<script>
import MaskComponent from '@/components/base/mask'
import PrizeNum from '@/components/business-base/prize-num'
import DialogButton from '@/components/business-base/dialog-button'

export default {
  components: {
    MaskComponent,
    PrizeNum,
    DialogButton
  },
  computed: {
    getDialogButtonText () {
      return this.$bus.transify['FESTA_CONFIRM']
    },
    getClass () {
      return `prize-item-img-${this.$bus.shopType}`
    },
    getText () {
      if (this.$bus.prize.given_token) {
        return this.$bus.transify['UNIQUE_REDEEM_ALREADY_HAVE']
      }
      return this.$bus.transify['COMMON_TIPS_ITEM']
    },
    getDialogSpendTitle () {
      let currentText = this.$bus.replaceText(this.$bus.transify['FESTA_GEM_CONFRIM'], `${Math.floor(this.$bus.prize.price * (100 - this.$bus.currentDiscount) / 100)}`)
      if (!currentText) {
        currentText = 'FESTA_GEM_CONFRIM'
      }
      return currentText
    },
    getPrice () {
      return Math.floor(this.$bus.prize.price * (100 - this.$bus.currentDiscount) / 100)
    }
  },
  methods: {
    confirm (item) {
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      const { pk, price } = this.$bus.prize
      const discountPrice = Math.floor(price * (100 - this.$bus.currentDiscount) / 100)
      // 1表示大折扣， 0表示小折扣
      const discount = this.$bus.bigDiscount[index] !== 0 && this.$bus.bigDiscount[index] !== -1 && !this.$bus.ticketBgMarkFlag ? 1 : 0
      this.$api.purchase({
        shop: index, // 0 1 2
        pk,
        discount,
        price: discountPrice
      }).then(res => {
        this.$bus.gems -= discountPrice
        this.$bus.prize = {}

        // 购买完更新当前cost
        const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
        this.$bus.currentCost += discountPrice
        this.$bus.cost[index] += discountPrice

        // 如果是通过大折扣购买
        if (discount === 1) {
          this.$bus.useBig[index][pk] = this.$bus.currentDiscount
          this.$bus.currentDiscount = this.$bus.discount[index]
          this.$bus.bigDiscount.splice(index, 1, -1)
          this.$bus[`inuse${this.$bus.shopType}`] = false
        }

        // 购买完更新shop
        this.$bus.updateShop(pk)

        this.handleDialogCharacterTextStatus()

        this.$bus.spendDialogShow = false
        this.$bus.toast = {
          show: true,
          content: this.$bus.transify['FESTA_TOAST_2'],
          closeable: true
        }
      })
    },
    handleDialogCharacterTextStatus () {
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)

      // 判断消费额度是否满足领券，但是还未领取
      if (this.$bus.bigDiscount[index] === 0 && this.$bus.currentCost >= this.$bus.costLimit[index]) {
        this.$bus.dialogCharacterTextStatus = 'ticket'
        return
      }

      // 判断是否已经购买了所有物品
      if (this.$bus.isPurchaseAll()) {
        this.$bus.dialogCharacterTextStatus = 'all'
        return
      }

      this.$bus.dialogCharacterTextStatus = 'purchase'
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-spend {
  color: $white;

  .dialog-spend-title {
    @include px2res(margin-bottom, 20);
    font-family: $main-font-family;
    @include px2res(font-size, 36);
    text-align: center;
  }

  .prize-item {
    @include flexdcac;

    .prize-item-img {
      position: relative;
      @include flexrc;
      @include px2res(width, 146);
      @include px2res(height, 141);

      img {
        max-width: 75%;
        max-height: 75%;
      }
    }

    .prize-item-name {
      @include px2res(padding, 8, 0);
      font-family: $main-font-family;
      font-weight: 300;
      @include px2res(font-size, 32);
    }

    .prize-item-price {
      display: flex;
      align-items: flex-end;
      @include px2res(margin, 8, 0);

      .prize-item-price-discount {
        @include flexac;

        .diamond {
          @include px2res(width, 30);
          @include px2res(height, 27);
        }

        .prize-item-price-discount-value {
          @include px2res(padding, 0, 8);
          @include px2res(font-size, 40);
        }
      }

      .prize-item-price-origin {
        position: relative;
        @include flexac;

        .diamond {
          @include px2res(width, 22);
          @include px2res(height, 20);
        }

        .prize-item-price-origin-value {
          @include px2res(font-size, 29);
        }

        .del {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          height: 2px;
        }
      }
    }
  }

  .dialog-spend-button {
    @include flexjc;
  }

  .dialog-spend-tip {
    @include flexjc;
    @include px2res(padding-top, 6);
    @include px2res(font-size, 20);
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/spend/index.vue